module.exports = __webpack_public_path__ + "static/media/Colle_CSO.3347c40d.svg";